import React, {useCallback, useEffect, useState} from 'react';
import apis from "services";
import {useQuery} from "react-query";
import {useHistory} from "react-router-dom";
import {setLabelAction} from "redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {DesktopDrawer, MobileDrawer} from "components";

/*==========    Material UI Components  ==========*/
import {makeStyles} from "@material-ui/styles";
import {useMediaQuery, useTheme} from "@material-ui/core";
import EventEmitter from "reactjs-eventemitter";

const useStyles = makeStyles(theme => ({
    toolbarMargin: {
        ...theme.mixins.toolbar,
        [theme.breakpoints.up('md')]: {
            marginTop: '2.5em'
        }
    },
    drawer: {
        width: 150,
        [theme.breakpoints.down('sm')]: {
            width: 200,
        },
        flexShrink: 0,
    },
    drawerPaper: {
        width: 150,
        [theme.breakpoints.down('sm')]: {
            width: 200,
        },
    },
    drawerOpen: {
        width: 150,
        [theme.breakpoints.down('sm')]: {
            width: 200,
        },
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(8) + 1,
        },
    }
}));

const Sidebar = ({open, setOpen}) => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const dispatch = useDispatch();
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'))
    const matchesXS = useMediaQuery(theme.breakpoints.down('xs'))

    const [subTabs, setSubTabs] = useState(true);

    const {directory, tabs, user} = useSelector(state => state?.inbox);

    const handleCollapse = useCallback(() => setSubTabs(!subTabs), [subTabs]);
    const handleNavigate = useCallback((path) => {
        history.push(path);
        matchesSM && setOpen(false)
        // eslint-disable-next-line
    }, [history, matchesSM,])

    const {refetch} = useQuery('labels', apis.labelsApi, {
        onSuccess: ({data}) => dispatch(setLabelAction(data)),
        enabled: true
    });

    useEffect(() => {
        EventEmitter.subscribe('refetch-messages', async () => {
            await refetch();
        })
    }, [refetch])

    const drawerProps = {subTabs, classes, handleCollapse, handleNavigate, directory, open}
    return (
        <>
            {matchesSM
                ? <MobileDrawer tabs={tabs} user={user} setOpen={setOpen} matchesXS={matchesXS}{...drawerProps}/>
                : <DesktopDrawer {...drawerProps} />
            }
        </>
    )
};

export default Sidebar;
